<template>
    <!--
        Overlay de carregamento exibido como modal do Bootstrap (aviso compacto, aparece após um breve atraso).
        Os componentes abrem/fecham via $('#id').modal('show'|'hide').
        Estilos em resources/sass/_carregando.scss (compartilhados com a transição de páginas).
    -->
    <div class="modal ld-overlay" data-backdrop="static" data-keyboard="false" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id+'Label'" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ld-dialogo" role="document">
            <div class="ld-cartao" role="status" aria-live="polite">
                <span class="ld-giro" aria-hidden="true"></span>

                <p class="ld-titulo" :id="id+'Label'" v-html="titulo"></p>

                <!-- fecha o loading e avisa o componente pai para abortar a requisição, quando ele tratar o evento -->
                <button type="button" class="ld-cancelar" data-dismiss="modal" :id="'btnCancelar'+id" @click="cancelaRequisicao()">Cancelar</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // semPadding e gifCarregando são mantidas por compatibilidade com os usos existentes
    props:['id','titulo','semPadding','gifCarregando'],
    methods:{
        cancelaRequisicao(){
            this.$emit('cancelaRequisicao');
        },
    }
}
</script>
